<template>
  <div class="d-flex justify-content-between flex-wrap" style="margin-bottom: 24px; gap: 4px">
    <h2>Insights</h2>
    <div class="search-input-container">
      <IconMagnifyingGlass />
      <input
        v-model="searchValue"
        class="form-control"
        type="text"
        placeholder="Search for name, title..."
        :disabled="insightStore.isLoading"
        @input="debouncedSearch"
      />
    </div>
  </div>

  <div class="d-flex gap-2 flex-wrap mb-3 align-items-center">
    <button
      :disabled="insightStore.isLoading"
      :class="[
        'btn',
        'btn-filters',
        'btn-bordered',
        'btn-outlined-black',
        { active: insightStore.selectedInsightCategory == '' }
      ]"
      @click="changeSelectedCategory('')"
    >
      <span>All</span>
    </button>
    <button
      v-for="availableCategory in insightStore.availableCategories"
      :key="availableCategory"
      :disabled="insightStore.isLoading"
      :class="[
        'btn',
        'btn-filters',
        'btn-bordered',
        'btn-outlined-black',
        { active: insightStore.selectedInsightCategory == availableCategory }
      ]"
      @click="changeSelectedCategory(availableCategory)"
    >
      <span>{{ availableCategory }}</span>
    </button>
  </div>

  <div class="d-flex justify-content-between mb-2 align-items-center" style="height: 44px">
    <div v-if="insightStore.items.length > 0" class="results">
      {{
        insightStore.items.length > insightStore.size
          ? 'Showing 1 - ' + insightStore.size + ' of ' + insightStore.totalResults + ' results'
          : 'Showing 1 - ' + insightStore.totalResults + ' results'
      }}
    </div>
    <div v-else class="results"> 0 results </div>
    <div class="view-all" v-if="insightStore.items.length > 0">
      <button class="btn btn-light pb-2" @click="toggleModal">View All</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import debounce from 'lodash/debounce'
import { ref } from 'vue'
import { useInsightModalStore } from '~/stores/modals/insight-modal'

const debouncedSearch = debounce(() => insightStore.setSearchValue(searchValue.value), 1000)
const insightStore = useInsightModalStore()
const searchValue = ref(insightStore.searchValue)

function changeSelectedCategory(categoryName: string) {
  if (categoryName === insightStore.selectedInsightCategory) {
    insightStore.setSelectedInsightCategory('')
    return
  }
  insightStore.setSelectedInsightCategory(categoryName)
}

function toggleModal() {
  insightStore.setViewAllPreview()
}
</script>
